// angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouteReuseStrategy } from "@angular/router"
import { CustomRouteReuseStrategy } from './custom-route-reuse-strategy';

// third party
import { UiSwitchModule } from 'ngx-ui-switch';

// modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { BaseModule } from './base/base.module';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { ComponentsModule } from './components/components.module';
import { UsersModule } from './users/users.module';
import { HospitalsModule } from './hospitals/hospitals.module';
import { VenuesModule } from './venues/venues.module';
import { PromoCodeModule } from './promo-code/promo-code.module';
import { ProvidersModule } from './providers/providers.module';
import { PayerModule } from './payer/payer.module';
import { ReasonTypesModule } from './reason-types/reason-types.module';
import { ReportsModule } from './reports/reports.module';
import { RideshareAvailabilityModule } from './rideshare-availability/rideshare-availability.module';

// app component
import { AppComponent } from './app.component';
import {environment} from '../environments/environment';
import { LocationsModule as HospitalLocationsModule } from './hospitals/locations/locations.module';
import { LaunchDarklyService } from './core/launchdarkly.service';
import { FederatedIdentityGroupsModule } from './federated-identity-groups/federated-identity-groups.module';
import { CustomersModule } from './customers/customers.module';
import { LocationCollectionsModule } from './location-collections/location-collections.module';
import { LocationsModule } from './locations/locations.module';

import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara'



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    UiSwitchModule,
    AppRoutingModule,
    CoreModule,
    BaseModule,
    AuthModule.forRoot({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      httpInterceptor: {
        allowedList: [
          {
            // Match any request that starts 'https://YOUR_DOMAIN/api/v2/' (note the asterisk)
            uri: environment.appurl + '*',
          }
        ]
      },
      authorizationParams: {
        audience: environment.appurl,
        redirect_uri: environment.auth0CallbackUrl,
      }
    }),
    ComponentsModule,
    UsersModule,
    HospitalsModule,
    ReasonTypesModule,
    HospitalLocationsModule,
    LocationsModule,
    LocationCollectionsModule,
    VenuesModule,
    PromoCodeModule,
    ProvidersModule,
    PayerModule,
    ReportsModule,
    RideshareAvailabilityModule,
    FederatedIdentityGroupsModule,
    CustomersModule,
  ],

  providers: [
    LaunchDarklyService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Lara
      }
    })
  ],

  bootstrap: [ AppComponent ]
})
export class AppModule { }
